import fetcher from '../lib/fetcher'
import {TPermissionResponse} from '../types/permission.type'

const getPermissionsForClient = async (
  clientId: string,
): Promise<TPermissionResponse> => {
  const response = await fetcher.get<TPermissionResponse>(
    `/api/permission/client/${clientId}`,
  )
  return response.data!
}

export const PermissionService = {
  getPermissionsForClient,
}
